<div class="n-wrapper-div">
    @if (loading()) {
    <div class="n-spinner-overlay">
        <mat-spinner></mat-spinner>
    </div>
    }
    <h2>Manage reference data</h2>
    <div class="button-grid">
        @for (item of buttonItems; track item.key) {
        <button mat-stroked-button class="grid-btn" (click)="onButtonClick(item.key)">
            <mat-icon>{{ item.icon }}</mat-icon>
            {{ item.label }}
        </button>
        }
    </div>

    <h2>Misc</h2>
    <div class="button-grid">
        @for (item of buttonMiscItems; track item.key) {
        <button mat-stroked-button class="grid-btn" style="grid-column: 2;" (click)="onButtonClick(item.key)">
            <mat-icon>{{ item.icon }}</mat-icon>
            {{ item.label }}
        </button>
        }
    </div>
</div>

<div class="buildinfo">
    Version {{ build.version }} ({{ build.buildTime }})
</div>